/* eslint-disable react/no-danger, no-console, jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { saveItemToAccount, removeItemFromAccount } from '../../modules/consumer-account/storage-actions';
import { getIdFromAssetUrl } from '../../modules/widen-utils';
import {
  getEmailShareUrl,
  getFacebookShareUrl,
  getPinterestShareUrl,
  getTwitterShareUrl,
} from '../../utils/social-media-sharing';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      captionMinimized: false,
    };
    // Add handlers
    this.modalClickHandler = this.modalClickHandler.bind(this);
    this.addToSwatchbookHandler = this.addToSwatchbookHandler.bind(this);
    this.removeFromSwatchbookHandler = this.removeFromSwatchbookHandler.bind(this);
    this.captionTitlebarClickHandler = this.captionTitlebarClickHandler.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.captionRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.modalClickHandler);
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate() {
    this.handleResize();
    this.setModalFocus();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.modalClickHandler);
    window.removeEventListener('resize', this.handleResize);
  }

  setCaptionPosition() {
    const { captionMinimized } = this.state;
    if (!captionMinimized && this.captionRef.current !== null) {
      this.captionRef.current.style.bottom = `-${this.captionRef.current.offsetHeight - 36}px`;
    } else {
      this.captionRef.current.removeAttribute('style');
    }
  }

  setModalFocus() {
    const { active } = this.props.modal;
    const modalDiv = this.captionRef.current;
    if (active && modalDiv !== null) {
      const lightGalleryCloseBtn = document.querySelector('.lg-close.lg-icon');
      if (lightGalleryCloseBtn) {
        lightGalleryCloseBtn.focus();
      } else {
        // Video modal only
        modalDiv.focus();
      }
    }
  }

  handleResize() {
    const { captionMinimized } = this.state;
    const { active, item } = this.props.modal;
    const modalDiv = this.captionRef.current;
    if (captionMinimized && modalDiv !== null) {
      modalDiv.removeAttribute('style');
      // Somehow inheriting height from video modal?
      modalDiv.querySelector('.caption-inner').removeAttribute('style');
      modalDiv.style.bottom = `-${modalDiv.offsetHeight - 36}px`;
    }
    if (active && item.type === 'Video' && modalDiv !== null) {
      const contentHeight = modalDiv.querySelector('.modal-content').offsetHeight;
      modalDiv.removeAttribute('style');
      modalDiv.querySelector('.modal-panel').style.height = `${contentHeight + 30}px`;
    }
  }

  formatThumbnailUrl() {
    const { imageUrl } = this.props.modal.item;
    return (imageUrl.indexOf('1024px') !== -1) ? imageUrl.replace(/1024px/, '360px') : imageUrl;
  }

  resetGalleryFocus() {
    const { item } = this.props.modal;
    if (!item.id) {
      return;
    }
    const btnSelector = `#${item.type.toLowerCase()}-${item.id} button`;
    const galleryItemBtn = document.querySelector(btnSelector);
    if (galleryItemBtn) {
      galleryItemBtn.focus();
    }
  }

  captionTitlebarClickHandler() {
    const { captionMinimized } = this.state;
    this.setState(() => ({
      captionMinimized: !captionMinimized,
    }));
    this.setCaptionPosition();
  }

  modalClickHandler(event) {
    const { item } = this.props.modal;
    const { handleModalClick } = this.props;
    if (event.target.classList.contains('modal') && event.target.classList.contains('modal-visible')) {
      handleModalClick(item);
      this.resetGalleryFocus();
    } else if (event.target.classList.contains('close-btn') || event.target.classList.contains('modal-overlay') || event.target.classList.contains('lg-close')) {
      handleModalClick(item);
      this.resetGalleryFocus();
    }
  }

  addToSwatchbookHandler(event) {
    event.stopPropagation();
    /* this.setState(() => ({
      captionMinimized: false,
    })); */
    // this.setCaptionPosition();
    const { item } = this.props.modal;
    const {
      imageUrl,
      description,
      productLineName,
      productLineId,
    } = item;
    const { updateModal } = this.props;

    saveItemToAccount(
      'photo',
      {
        imageUrl,
        thumbUrl: this.formatThumbnailUrl(),
        description,
        productLineId,
        productLineName,
      },
      (data) => {
        // console.log(data);
        if (data.success) {
          updateModal(item);
        }
      },
    );
  }

  removeFromSwatchbookHandler(event) {
    event.stopPropagation();
    const { item } = this.props.modal;
    const { assetId, updateModal } = this.props;
    removeItemFromAccount(
      'photo',
      assetId,
      () => {
        updateModal(item);
      },
    );
  }

  render() {
    const { active, item } = this.props.modal;
    const { savedToFavorites, assetId } = this.props;
    const { captionMinimized } = this.state;
    const { location, PhotoShareUrl } = window;
    const { origin } = location;
    let shareLink = '';
    if (item) {
      if (item.type === 'Image') {
        // Set sharelink html
        shareLink = encodeURIComponent(`${origin}${PhotoShareUrl}#${getIdFromAssetUrl(item.imageUrl)}`);
        // Update alt tag in lightgallery modal image
        const modalImg = document.querySelector('.lg-current .lg-object.lg-image');
        if (modalImg) {
          modalImg.setAttribute('alt', item.description);
        }
      }
    }
    return (
      <div className="gallery-modal-container photo-video-gallery">
        {(item !== '' && item !== undefined && active)
        ? (
          <div>
            {item.type === 'Video'
            ? (
              <div ref={this.captionRef} className={`modal gallery-modal ${active ? 'modal-visible' : ''}`} id={`modal-${item.id}`} tabIndex={0}>
                <div className="modal-overlay" />
                <div className="modal-panel">
                  <button type="button" className="close-btn" aria-label="Close Modal" onClick={event => this.modalClickHandler(event)} ref={this.closeBtnRef} />
                  <div className="modal-inner">
                    <div className="container modal-content">
                      <div className="row row-eq-height">
                        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-9">
                          <div className="modal-video">
                            <iframe id="modal-iframe" className="modal-iframe" src={`${item.videoUrl}/?rel=0`} title={item.title} allowFullScreen />
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-3">
                          <div className="modal-description">
                            <h2 className="modal-title" id={`modal-label-${item.id}`}>{item.title}</h2>
                            <div className="video-description">
                              <p dangerouslySetInnerHTML={{ __html: item.description }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div ref={this.captionRef} className={`gallery-modal-caption${active ? '' : ' hidden'}${captionMinimized ? ' minimized' : ''}`} id={`modal-${item.id}`} aria-labelledby={`modal-label-${item.id}`}>
                <div className="d-flex justify-content-between">
                  <button className="caption-titlebar" aria-expanded={!captionMinimized} onClick={() => this.captionTitlebarClickHandler()}>
                    <div className="caption-title">
                      <span className="icon" />
                      About this Photo
                    </div>
                  </button>
                  {(savedToFavorites)
                  ? (
                    <button className="btn btn-sm btn-primary o-iconBtn add-photo-btn d-flex align-items-center" data-asset-id={`${savedToFavorites ? assetId : ''}`} onClick={event => this.removeFromSwatchbookHandler(event)}>
                      <div className="icon icon--minus m-0 ms-2" />
                      <span className="p-2">Remove<span className="sr-only"> Photo</span> from Favorites</span>
                    </button>
                  ) : (
                    <button className="btn btn-sm btn-primary o-iconBtn add-photo-btn d-flex align-items-center" onClick={event => this.addToSwatchbookHandler(event)}>
                      <div className="icon icon--plus--white m-0 ms-2" />
                      <span className="p-2">Add<span className="sr-only"> Photo</span> to Favorites</span>
                    </button>
                  )}
                </div>
                <div className="caption-inner">
                  <div className="caption-inner-left">
                    <div className="fs-sm text-uppercase">Product Description</div>
                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                  </div>
                  <div className="caption-inner-right">
                    <div className="fs-sm text-uppercase">Share Photo</div>
                    <div>
                      <ul className="list-unstyled d-flex flex-row justify-content-between mb-0">
                        <li><a href={`${getFacebookShareUrl()}${shareLink}`} title="Facebook" className="share-fb-link link" id="share-fb" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                        <li className="ml-4"><a href={`${getTwitterShareUrl()}Check out this photo from the Graber Design Gallery&url=${shareLink}`} title="Twitter" className="share-tw-link link" id="share-tw" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                        <li className="ml-4"><a href={`${getPinterestShareUrl()}${shareLink}&media=${item.imageUrl}&description=${item.description}`} title="Pinterest" className="share-pt-link link" id="share-pt" target="_blank" rel="noopener noreferrer">Pinterest</a></li>
                        <li className="ml-4"><a href={`${getEmailShareUrl()}Check%20out%20this%20photo%20from%20the%20Graber%20Design%20Gallery&body=Photo%20link%3A%20${shareLink}%0A%0AAbout%20this%20photo%3A%20'${item.description}`} title="Email" className="share-em-link link" id="share-em" target="_blank" rel="noopener noreferrer">Email</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : ''}
      </div>
    );
  }
}

Modal.propTypes = {
  handleModalClick: PropTypes.func.isRequired,
  modal: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    item: PropTypes.shape(PropTypes.object.isRequired),
  }),
  savedToFavorites: PropTypes.bool.isRequired,
  assetId: PropTypes.string.isRequired,
  updateModal: PropTypes.func.isRequired,
};

export default Modal;
/* eslint-enable react/no-danger, no-console, jsx-a11y/no-noninteractive-tabindex */
